'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMenuItems = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _DropdownSubmenu = require('./DropdownSubmenu');

var _DropdownSubmenu2 = _interopRequireDefault(_DropdownSubmenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMenuItems = function getMenuItems(items) {
    return items.map(function (element, index) {
        var value = element.value,
            elementProps = (0, _objectWithoutProperties3.default)(element, ['value']);


        if (value && value.type === _DropdownSubmenu2.default) {
            // key has to be set but is readonly
            var subMenu = Object.assign({}, value, { key: '' + index });
            return subMenu;
        }

        return _react2.default.createElement(
            _reactBootstrap.MenuItem,
            (0, _extends3.default)({ key: '' + index, eventKey: '' + index }, elementProps),
            value
        );
    });
};
exports.getMenuItems = getMenuItems;